import "@/plugins/firebase";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import ECharts from "vue-echarts";
import "vuetify/dist/vuetify.min.css";
import App from "@/App.vue";
import "@/plugins/axios";
import vuetify from "@/plugins/vuetify";
import router, { setRouterGlobalGuards } from "@/router";

setRouterGlobalGuards();

import VueGtag from "vue-gtag";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles

import DatetimePicker from "vuetify-datetime-picker";
import "@/plugins/vuetify-money.js";
import store from "@/store";

import loggingService from "@/services/LoggingService";
loggingService.setStore(store);
loggingService.setRouter(router);

import ActionButtons from "@/components/base/ActionButtons.vue";
import Alert from "@/components/base/Alert";
import HeaderDialog from "@/components/base/HeaderDialog";
import Logo from "@/components/base/Logo";
import NewsTip from "@/components/base/NewsTip.vue";
import Popover from "@/components/base/Popover";
import ProductButton from "@/components/base/ProductButton";
import SimpleDialog from "@/components/base/SimpleDialog";
import TableHeader from "@/components/base/TableHeader";
import TooltipIcon from "@/components/base/TooltipIcon";
import UserBadge from "@/components/base/UserBadge";
import playVideoButton from "@/components/base/playVideoButton";
import Snackbar from "@/components/general/Snackbar";
import DialogHasProductAccess from "@/components/home/dialogs/DialogHasProductAccess.vue";
import HeaderTitle from "@/components/main/shared/HeaderTitle.vue";
import { i18n } from "@/plugins/vue-i18n";
import { CsSnackbar } from "@conecta-suite/vue2-components";
import "@conecta-suite/vue2-components/dist/vue2-components.css";
import VSnackbars from "v-snackbars";
import VueTelInputVuetify from "vue-tel-input-vuetify/lib";
import tinymce from "tinymce";
tinymce.baseURL = "/tinymce";

import "@/plugins/vue-tour";
import ObservabilityPlugin from "@/plugins/observability";

Vue.use(
  VueGtag,
  {
    config: { id: "UA-148164433-3" },
  },
  router
);

Vue.use(VueTelInputVuetify, {
  vuetify,
});

Vue.component("PrismEditor", PrismEditor);
Vue.component("Alert", Alert);
Vue.component("SimpleDialog", SimpleDialog);
Vue.component("HeaderDialog", HeaderDialog);
Vue.component("Snackbar", Snackbar);
Vue.component("CsSnackbar", CsSnackbar);
Vue.component("Logo", Logo);
Vue.component("TableHeader", TableHeader);
Vue.component("v-snackbars", VSnackbars);
Vue.component("v-play-video-button", playVideoButton);
Vue.component("DialogHasProductAccess", DialogHasProductAccess);
Vue.component("UserBadge", UserBadge);
Vue.component("TooltipIcon", TooltipIcon);
Vue.component("ProductButton", ProductButton);
Vue.component("Popover", Popover);
Vue.component("HeaderTitle", HeaderTitle);
Vue.component("ActionButtons", ActionButtons);
Vue.component("NewsTip", NewsTip);
// Vue.component("cropper", Cropper);
// Vue.component("bounding-box", BoundingBox);

Vue.use(VueClipboard);

Vue.use(DatetimePicker);

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: "mdi",
});

Vue.use(require("vue-moment"));

Vue.use(ObservabilityPlugin);

Vue.config.productionTip = false;
Vue.component("v-chart", ECharts);

let handleOutsideClick;
Vue.directive("closable", {
  bind(el, binding, vnode) {
    // Here's the click/touchstart handler
    // (it is registered below)
    handleOutsideClick = (e) => {
      e.stopPropagation();
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      const { handler, exclude } = binding.value;
      // This variable indicates if the clicked element is excluded
      let clickedOnExcludedEl = false;
      exclude.forEach((refName) => {
        // We only run this code if we haven't detected
        // any excluded element yet
        if (!clickedOnExcludedEl) {
          // Get the element using the reference name
          const excludedEl = vnode.context.$refs[refName];
          // See if this excluded element
          // is the same element the user just clicked on
          if (excludedEl) {
            clickedOnExcludedEl = excludedEl.contains(e.target);
          }
        }
      });
      // We check to see if the clicked element is not
      // the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]();
      }
    };
    // Register click/touchstart event listeners on the whole page
    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
  },
  unbind() {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener("click", handleOutsideClick);
    document.removeEventListener("touchstart", handleOutsideClick);
  },
});

new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
